var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
let Monitoring = class Monitoring extends Vue {
    id = this.$route.params.id;
    search = '';
    Overtime = [];
    Undertime = [];
    snackbar = false;
    Counts = [
        { text: '', value: "" },
        { text: '', value: "" },
        { text: '', value: "" },
        { text: '', value: "" },
        { text: '', value: "" },
        { text: '', value: "" }
    ];
    timeout = 5000;
    loading = true;
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 1
    };
    headers = [
        { text: 'Ordernummer', value: 'order_nr', },
        { text: 'Artikel', value: 'article' },
        { text: 'Kunde', value: 'customer' },
        { text: 'Lieferdatum', value: 'delivery_date' },
        { text: 'EndKontrolle', value: 'final_control' },
        { text: 'Notiz', value: 'note' },
    ];
    getJobList() {
        this.loading = true;
        axios.get('/api/jobs/monitoring', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
            }
        }).then((response) => {
            this.Overtime = response.data.data['AllOvertimeJobs'];
            this.Counts = [
                { text: 'Aufträge in 3 Tagen überfällig', value: response.data.data['Count3dayOvertimeJobs'] },
                { text: 'Heute erstellte Aufträge', value: response.data.data['CountAllCreatedJobsToday'] },
                { text: 'Heute bearbeitete Aufträge', value: response.data.data['CountAllEditJobsToday'] },
                { text: 'Alle offene Aufträge', value: response.data.data['CountAllJobs'] },
                { text: 'Heute fällige Aufträge', value: response.data.data['CountAllJobsToday'] },
                { text: 'Alle überfällige Aufträge', value: response.data.data['CountAllOvertimeJobs'] }
            ];
            if (response.data.meta.per_page) {
                this.options.itemsPerPage = parseInt(response.data.meta.per_page);
            }
            if (response.data.meta.current_page) {
                this.options.page = parseInt(response.data.meta.current_page);
            }
            if (response.data.meta.total) {
                this.options.total = parseInt(response.data.meta.total);
            }
            this.loading = false;
        });
        this.loading = false;
        return this.Overtime;
    }
    mounted() {
        this.$store.state.monitor = true;
        axios.get("/sanctum/csrf-cookie").then((_) => {
            axios.get('/api/user').then((response) => {
                if (response.status === 200) {
                    this.$store.state.user = response.data.data;
                    this.getJobList();
                    setInterval(this.getJobList, 30000);
                }
                else {
                    this.$store.state.user = null;
                }
            }).catch((error) => {
                this.$store.commit('logout');
            });
        });
        this.$vuetify.theme.dark = true;
    }
};
Monitoring = __decorate([
    Component({
        name: "Monitoring",
    })
], Monitoring);
export default Monitoring;
